import React, { useEffect, useState } from "react";


import "../exercise1/Exercise1Intro.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise3Intro = () => {
  const [selectedDuration, setSelectedDuration] = useState(5); // Default to 1 minute
  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
    Exercise 3 will train your peripheral vision. Breathe rhythmically as usual.
  </span>`
  );
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const [userData, setUserData] = useState(null); // We added this
  const navigate = useNavigate();

  const durations = [5, 10]; // List of durations

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);

        // ✅ Automatically select the next available duration
        if (data.numExercisesUnlocked >= 1) {
          const nextUnlocked = durations.find(duration => duration >= data.currNumLevelsUnlocked);
          if (nextUnlocked) {
            setSelectedDuration(nextUnlocked);
          }
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  // We added this
  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false; // Assume locked if user data isn't loaded
    return userData.exercisesUnlocked[2] >= levelNumber;
  };

  const handleDurationClick = (duration) => {
    setSelectedDuration(duration);
  };

  const handleStartClick = () => {
    navigate("/exercise3workout", { state: { duration: selectedDuration } });
  };

  const handleVideoClick = () => {
    navigate("/exercise3video");
  };

  let handleNextNextClick = () => {
    setSunnyHTML(`<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
Repeat the exercise until you can:<br><br>

1. <b>maintain rhythmic breathing</b> 95% of the time <br>
2. <b>capture the words</b> 95% of the time <br>
3. <b>comprehend the words</b> 95% of the time <br><br>

At that point,  advance to the next exercise!
</span>`);
    setBubbleHeight(250);
    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
      Keep focused at center of the screen, using peripheral vision to see the words.
    </span>`
    );
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button
          className="guidance-and-start-button"
          onClick={handleStartClick}
        >
          Start
        </button>
      );
    } else {
      return (
        <button
          className="guidance-and-start-button"
          onClick={
            sunnyHTML.includes("Exercise 3")
              ? handleNextClick
              : handleNextNextClick
          }
        >
          Next
        </button>
      );
    }
  };

  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
        <h3>Choose Duration (minutes):</h3>
        <div className="duration-selection">
          <div className="durations">
            {durations.map((duration, index) => (
              <button
                key={duration}
                className={`duration-button ${
                  selectedDuration === duration ? "selected" : ""
                }`}
                onClick={() => handleDurationClick(duration)}
                disabled={!isLevelUnlocked(index + 1)}
                style={{
                  backgroundColor: isLevelUnlocked(index + 1) ? "#4CAF50" : "#CCCCCC",
                  cursor: isLevelUnlocked(index + 1) ? "pointer" : "not-allowed"
                }}
              >
                {duration}
              </button>
            ))}
          </div>
        </div>
        <p className="hint">Hint: Complete levels to unlock more</p>
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={600}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {/* <button
          className="guidance-and-start-button"
          onClick={handleVideoClick}
        >
          Guidance Video
        </button> */}
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise3Intro;
